import { render, staticRenderFns } from "./ReturnItemDialog.vue?vue&type=template&id=5f5273fe&scoped=true"
import script from "./ReturnItemDialog.vue?vue&type=script&lang=js"
export * from "./ReturnItemDialog.vue?vue&type=script&lang=js"
import style0 from "./ReturnItemDialog.vue?vue&type=style&index=0&id=5f5273fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5273fe",
  null
  
)

export default component.exports